import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Image,
  Toast,
  Card,
  Table,
} from "react-bootstrap";
import Loader from "../gif/loader.gif";
import Scan from "../gif/scan.gif";
import Profile from "../gif/profile.png";
import { FaCheck, FaEnvelope, FaPhone, FaLocationArrow } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Check from "../gif/check.png";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import CardDesign from "../components/Card";
import RowTitles from "../components/RowTitles";

const ScanCard = () => {
  const navigate = useNavigate();
  const { param } = useParams();
  //
  const [tagId, setTagId] = useState();
  const [member, setMember] = useState({});
  const [recentMembers, setRecentMembers] = useState([]);
  //toast
  const [show, setShow] = useState(false);
  const [resultText, setResultText] = useState();
  const [bgclass, setBgClass] = useState();
  //loading
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTagId("");
    loadRecentlyScanned();
    const ws = new WebSocket("ws://localhost:8080");
    //console.log(ws);
    ws.onopen = () => {
      console.log("Connected to WebSocket server");
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.uid) {
        getMember(data.uid);
      } else if (data.message) {
        console.log(data.message);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed");
    };
    return () => {
      ws.close(); //Clean up WebSocket connection when component unmounts
    };
  }, []);
  const goToRegister = () => {
    navigate("/register");
  };
  const closeToast = () => {
    //close toast
    setShow(!show);
  };
  //when loggining
  const getMember = async (uid) => {
    setLoading(!loading);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-member?uid=${uid}`
      );
      let retcode = res.data;
      console.log(retcode);
      setMember(retcode);
      //update tag
      setTagId(uid);
      //stop loading
      setLoading(false);
      //show toast
      setShow(!show);
      //configure toast
      setResultText("Member Found");
      //set tast color
      setBgClass("success");
    } catch (error) {
      //stop loading
      setLoading(false);
      //show toast
      setShow(!show);
      //configure toast
      setResultText("Member not Found.");
      //set tast color
      setBgClass("danger");
      //
      clearDetails();
      console.log("post error =>" + error);
    }
  };
  const clearDetails = () => {
    setTagId("");
    setMember({});
  };
  const saveAttandance = async () => {
    setLoading(!loading);
    if (member) {
      let data = {
        name: member.name,
        surname: member.surname,
        cell: member.cell,
        tagid: tagId,
        event_title: param,
        scanner: "Admin",
        type: "Attandance",
      };
      console.log(data);
      try {
        const res = await axios.post(
          `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/save-attandance`,
          data
        );
        let retcode = res.data.message;
        //stop loading
        setLoading(false);
        //show toast
        setShow(!show);
        //configure toast
        setResultText(retcode);
        //set tast color
        setBgClass("success");
        //clear details
        clearDetails();
        loadRecentlyScanned();
      } catch (error) {
        //stop loading
        setLoading(false);
        //show toast
        setShow(!show);
        //configure toast
        setResultText("Attandace failed.. Please try again.");
        //set tast color
        setBgClass("danger");
        console.log("post error =>" + error);
      }
    }
  };
  const loadRecentlyScanned = async () => {
    setLoading(!loading);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-loadrecents`
      );
      let retcode = res.data;
      setRecentMembers(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("post error =>" + error);
    }
  };
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      <div className="flex-grow-1">
        <NavBar />
        <div className="container-fluid mt-4">
          <Row>
            <div className="col-md-8">
              <RowTitles title={"Dashboad"} child={"Mark attandance"} />
            </div>
            <div className="col-md-4 text-center">
              <Toast
                onClose={closeToast}
                show={show}
                delay={3000}
                bg={bgclass}
                autohide
              >
                <Toast.Body className="text-white">{resultText}</Toast.Body>
              </Toast>
            </div>
          </Row>
          {/* //main container */}
          <Container className="mt-3">
            {/* //main content container */}

            <Row
              style={{
                textAlign: "left",
                backgroundColor: "white",
                borderRadius: 20,
                padding: 20,
              }}
              className="d-flex align-items-center justify-content-center border border-mute"
            >
              {/* //main container row */}
              <Col md={6} sm={12} className="p-3 text-center">
                <CardDesign
                  cardUID={tagId}
                  name={member.name}
                  surname={member.surname}
                />
              </Col>
              <Col
                md={6}
                sm={12}
                className="text-center"
                style={{ height: "370px" }}
              >
                {tagId ? (
                  loading ? (
                    <img
                      src={Loader}
                      alt="QR Code"
                      width={"30"}
                      height={"30"}
                    />
                  ) : (
                    <Card
                      className="mx-auto shadow"
                      style={{
                        width: "18rem",
                        padding: "1rem",
                        textAlign: "center",
                        marginTop: "-10%",
                      }}
                    >
                      <Card.Img
                        variant="top"
                        src={Profile}
                        alt="Profile Picture"
                        className="rounded-circle mx-auto"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                        }}
                      />
                      <Card.Body>
                        <Card.Title className="text-center">
                          {member.name} {member.surname}
                          <br />
                          <small>{member.cell}</small>
                        </Card.Title>
                        <Card.Subtitle>
                          <span class="badge bg-info"> {member.gender}</span>
                        </Card.Subtitle>

                        <Card.Text className="fw-bold">
                          <small>
                            {" "}
                            {member.city}, {member.country}
                          </small>
                        </Card.Text>
                        <Row>
                          <Col xs={4}>
                            <Button variant="light" href={member.address}>
                              <FaLocationArrow size={24} color="lightgray" />
                            </Button>
                          </Col>
                          <Col xs={4}>
                            <Button variant="light" href={member.email}>
                              <FaEnvelope size={24} color="lightgray" />
                            </Button>
                          </Col>
                          <Col xs={4}>
                            <Button variant="light" href={member.cell}>
                              <FaPhone size={24} color="lightgray" />
                            </Button>
                          </Col>
                        </Row>
                        <hr />
                        <Row>
                          <p>
                            <b>Event</b>
                            <small>
                              : <b className="text-secondary">{param}</b>
                            </small>
                          </p>
                          <button
                            className="btn text-white me-2 w-100"
                            style={{
                              borderRadius: 0,
                              backgroundColor: "#33afe0",
                            }}
                            onClick={saveAttandance}
                          >
                            <FaCheck className="me-2" /> Mark Attandance
                          </button>
                        </Row>
                      </Card.Body>
                    </Card>
                  )
                ) : (
                  <p className="fw-bolder" style={{ color: "lightgray" }}>
                    NO TAG OR CARD DETECTED
                  </p>
                )}
              </Col>
            </Row>
            <div className="row">
              <div className="col-md-6 mt-3 mb-3">
                <RowTitles title={"Dashboad"} child={"Recently scanned"} />
              </div>
              <div className="col-md-6 text-end"></div>
            </div>
            {loading ? (
              <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
            ) : (
              <Table striped bordered hover className="shadow">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Surname</th>
                    <th>Cell</th>
                    <th>Card No</th>
                    <th>Event Name</th>
                    <th>Event Date</th>
                    <th>Attandace</th>
                    <th>Scanned By</th>
                  </tr>
                </thead>
                <tbody>
                  {recentMembers.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <small>{row.id}</small>
                      </td>
                      <td>
                        <small>{row.name}</small>
                      </td>
                      <td>
                        <small>{row.surname}</small>
                      </td>
                      <td>
                        <small>{row.cell}</small>
                      </td>
                      <td>
                        <small>{row.tagid}</small>
                      </td>
                      <td>
                        <small>{row.event_title}</small>
                      </td>
                      <td>
                        <small>{row.event_date}</small>
                      </td>
                      <td>
                        <small className="badg badge-warning">{row.type}</small>
                      </td>
                      <td>
                        <small>{row.scanner}</small>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Container>
        </div>
      </div>
    </div>
  );
};

export default ScanCard;
